var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"yuri-text",class:[{'ellipsis' : _vm.ellipsis}, `color-${_vm.color}`],style:(_vm.styleObject)},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }